// Config from env. Set REACT_APP_* in admin/.env (Create React App only exposes REACT_APP_*)

export const TIME_ZONE = process.env.REACT_APP_TIME_ZONE;
export const BACKEND_DOMAIN =
  process.env.REACT_APP_BACKEND_DOMAIN;
